import httpClient from "@hd/http-client/http-client";
import { AuthenticationResultDto } from "@hd/types/dto/auth/authentication-result.dto";

interface Params {
  username: string;
  mfaCode: string;
  remember: boolean;
}
export const verifyMfaRequest = async (data: Params) => {
  const result = await httpClient.post<AuthenticationResultDto>(
    import.meta.env.VITE_HD_API_URL + "/auth/verify-mfa",
    data,
    {
      // headers: {
      //   [SILENT_REQUEST_HEADER_KEY]: "true",
      // },
    }
  );

  return result.data;
};
